// src/components/Tree/TreeGraphRender.js

import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import TreeGraph from "./treeGraph";
import TreeFilter from "./TreeFilter";
import { getHierarchyTree } from "../../../api/getHierarchyTree";
import LoadingSpinner from "../../../utils/Loader/LoadingSpinner";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";


// New helper function to find a node by its glue_id in the data tree
const findNodeByGlueId = (node, glueId) => {
  // Assuming the glue_id is stored in the 'metadata' property
  if (node.metadata === glueId) {
    return node;
  }
  if (node.children) {
    for (const child of node.children) {
      const found = findNodeByGlueId(child, glueId);
      if (found) {
        return found;
      }
    }
  }
  return null;
};


const TreeGraphRender = () => {
  const { state } = useLocation();
  const glue_id_state = state?.glue_id;

  const [data, setData] = useState(null);
  const [layout, setLayout] = useState("vertical");
  const [selectedNode, setSelectedNode] = useState(null);
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // New state to hold the name of the focused company
  const [headerTitle, setHeaderTitle] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [submittedSearch, setSubmittedSearch] = useState("");

  const { glue_id } = useParams();

  useEffect(() => {
    if (searchTerm.trim() === "") {
      setSubmittedSearch("");
    }
  }, [searchTerm]);

  // Initial data fetch and node setup
  useEffect(() => {
    if (!glue_id) {
      setError("No glue_id provided.");
      return;
    };
    setLoading(true);

    const decodedId = decodeURIComponent(glue_id);

    const glueID = glue_id || decodedId;

    getHierarchyTree(glueID)
      .then((res) => {
        setData(res);

        // --- NEW: LOGIC FOR INITIAL NODE SELECTION ---
        const targetNodeData = findNodeByGlueId(res, glueID);

        if (targetNodeData) {
          // 1. Set this node as selected to show its details panel on load
          setSelectedNode(targetNodeData);
          setSelectedNodeId(targetNodeData.name);
          // 2. Set the header title to this company's name
          setHeaderTitle(targetNodeData.name);
        } else {
          // Fallback: If node isn't found, use the ultimate parent's name
          setHeaderTitle(res.name);
        }
        // --- END OF NEW LOGIC ---

        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Unknown error");
        setLoading(false);
      });
  }, [glue_id, glue_id_state]); // Dependency on glue_id ensures this runs on load

  if (loading)
    return (
      <>
        <Header
          navigateTo="/summary"
          headerName=""
          layout={layout}
          setLayout={setLayout}
        />
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", fontSize: '2vw' }}>
          <LoadingSpinner message="Loading Hierarchy" />
        </div>
      </>
    );

  if (error || !data)
    return (
      <>
        <Header headerName="" layout={layout} setLayout={setLayout} />
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          No Hierarchy Found
        </div>
      </>
    );

  const handleSearchChange = (val) => {
    setSearchTerm(val);
  };

  const handleSearchSubmit = () => {
    setSubmittedSearch(searchTerm.trim());
  };

  return (
    <div className="page-container">
      <Header
        // Use the new headerTitle state, with a fallback to the ultimate parent name
        headerName={headerTitle || (data ? data.name : "")}
        layout={layout}
        setLayout={setLayout}
        dataLength={data.children.length}
        data={data}
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
        onSearchSubmit={handleSearchSubmit}
      />

      <div className="page-content" style={{ position: "relative" }}>
        <TreeGraph
          data={data}
          layout={layout}
          selectedNodeId={selectedNodeId}
          setSelectedNode={setSelectedNode}
          setSelectedNodeId={setSelectedNodeId}
          searchTerm={submittedSearch}
        />
        {/* <TreeFilter
          selectedNode={selectedNode}
          onClose={() => {
            setSelectedNode(null);
            setSelectedNodeId(null);
          }}
        /> */}
      </div>

      <Footer />
    </div>
  );
};

export default TreeGraphRender;